export const CLEAR_TEMP_STORE_DATA = 'CLEAR_TEMP_STORE_DATA';

export const clearTempStoreData = ({ identifier }) => ({
    type: CLEAR_TEMP_STORE_DATA,
    payload: {
        identifier
    }
});
